import request from '@utils/request'
import gateway from '@enum/gateway'

export const sendSMS = args =>
  request.fetch(gateway.auth + '/v1/api/loginPwd/smsCaptcha', args)

export const resetPassword = args =>
  request.post(gateway.auth + '/v1/api/loginPwd/resetPwd', {
    phoneNo: args.phone,
    smsCode: args.smsCode,
    newPwd: args.newPassword
  })

export const checkAuthCode = args =>
  request.post(gateway.auth + '/v1/api/loginPwd/checkSmsCaptcha', {
    phoneNo: args.phone,
    smsCode: args.smsCode
  })

export const checkPassword = args =>
  // TODO encode query string
  request
    .fetch(gateway.auth + '/v1/api/loginPwd/check', {
      password: args.newPwd
    })
    .then(({ data = [] }) => {
      return data
    })

export const loginWithPwd = args =>
  request.post(gateway.auth + '/v1/system/pwdVerify', args)

export const loginWith2FA = args =>
  request.post(gateway.auth + '/v1/system/pcLogin', args)
